export const InformationApi = {
  information: '/information',
  informationFiles: '/information/files',
};
